import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const coreDataForm: Form<Client> = {
  key: 'coreData',
  title: 'Stammdaten',
  fields: [
    {
      key: 'advisor',
      label: 'Fallzuständigkeit',
      fieldTypes: 'text',
    },
    {
      key: 'date',
      label: 'Kontaktdatum',
      fieldTypes: 'date',
    },
    {
      key: 'caseId',
      label: 'Erfassungsbogen Fall-Nr.',
      fieldTypes: 'text',
    },
    {
      key: 'name',
      label: 'Name der Frau',
      fieldTypes: 'text',
    },
    {
      key: 'phone',
      label: 'Telefon',
      fieldTypes: 'text',
    },
    {
      key: 'anonymous',
      label: 'Anonym',
      fieldTypes: 'checkbox',
    },
    {
      key: 'address',
      label: 'Anschrift',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'location',
      label: 'Einzugsgebiet',
      fieldTypes: 'select',
      options: [
        {
          value: 'fuerth',
          label: 'Stadt Fürth',
        },
        {
          value: 'fuerthRegion',
          label: 'Landkreis Fürth',
        },
        {
          label: 'außerhalb',
          value: 'outside',
        },
      ],
    },
    {
      key: 'faxInput',
      label: 'Faxeingang',
      fieldTypes: 'date',
    },
    {
      key: 'incident',
      label: 'Vorfall am',
      fieldTypes: 'date',
    },
    {
      key: 'domesticViolence',
      label: 'HGW',
      fieldTypes: 'checkbox',
    },
    {
      key: 'exPartnerStalking',
      label: 'Ex-Partner Stalking',
      fieldTypes: 'checkbox',
    },
  ],
};

export default coreDataForm;
